<template>
  <section id="dashboard">
    <section class="sidebar" :class="{ expand: activeExpand, isdemo: isDemo }">
      <div class="logo center">
        <center>
          <img class="no-mobile" src="@/assets/img/icon.png" width="60" />
          <div class="app-title no-mobile">Parceiros Natal</div>
          <div class="mobile">
            <i class="fas fa-bars"></i>
          </div>
        </center>
      </div>

      <nav class="menu">
        <ul>
          <router-link v-if="checkResource('report')" :to="{ name: 'Report' }">
            <li :class="{ current: $route.name === 'Report' }">
              <i class="fas fa-tachometer-alt"></i>
              <span>Relatório</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('product')" :to="{ name: 'Product' }">
            <li
              :class="{
                current: $route.name && $route.name.includes('Product'),
              }"
            >
              <i class="fas fa-box"></i>
              <span>Link Produtos</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('sale')" :to="{ name: 'Sale' }">
            <li
              :class="{
                current: $route.name && $route.name.includes('Sale'),
              }"
            >
              <i class="fas fa-paper-plane"></i>
              <span>Vendas</span>
            </li>
          </router-link>


          <router-link v-if="checkResource('withdraw')" :to="{ name: 'Withdraw' }">
            <li
              :class="{ current: $route.name && $route.name.includes('Withdraw') }"
              class="block-module"
            >
              <i class="fas fa-mail-bulk"></i>
              <span>Saques</span>
            </li>
          </router-link>


          <router-link v-if="checkResource('config')" :to="{ name: 'ConfigAccount' }">
            <li :class="{ current: $route.name === 'ConfigAccount' }">
              <i class="fas fa-file-contract"></i>
              <span>Configuração</span>
            </li>
          </router-link>

          <hr />

          <a v-if="false" href="https://whatsapp.com/channel/0029Va8NcV00G0XbNp8jSq3T" target="_blank">
            <li>
              <i class="fab fa-whatsapp"></i>
              <span>Grupo no Whatsapp</span>
            </li>
          </a>

          <a v-if="false" href="https://drive.google.com/drive/folders/1cu3p7oAhiwocaypXyxGaxL1QFDNXdrha?usp=sharing" target="_blank">
            <li>
              <i class="fas fa-images"></i>
              <span>Material de Divulgação</span>
            </li>
          </a>

          <a v-if="false" href="https://linktr.ee/parceiros_bopoty" target="_blank">
            <li>
              <i class="fas fa-info"></i>
              <span>Links Úteis</span>
            </li>
          </a>

          <router-link v-if="false" :to="{ name: 'Canny' }">
            <li :class="{ current: $route.name === 'Canny' }">
              <i class="fas fa-bullhorn"></i>
              <span>Sugestões</span>
            </li>
          </router-link>

          <router-link v-if="hasMultipleAccounts" :to="{ name: 'Account' }">
            <li>
              <i class="fas fa-exchange-alt"></i>
              <span>Trocar</span>
            </li>
          </router-link>

          <a @click="logout()">
            <li>
              <i class="fas fa-sign-out-alt"></i>
              <span>Sair</span>
            </li>
          </a>
        </ul>
      </nav>
      <div
        v-if="false"
        class="expand-button"
        @click="activeExpand = !activeExpand"
      >
        <small v-if="!activeExpand">Expandir</small>
        <small v-else>Minimizar</small>
      </div>
    </section>

    <section class="main-content" :class="{ expand: activeExpand }">
      <section class="top-bar grid-flex middle between">
        <div class="main-filters flex middle">
          <breadcrumb></breadcrumb>
        </div>

        <div class="flex middle">
          <div v-if="false" class="" style="margin-right: 24px; padding: 12px 36px; border-right: 1px solid #c2c2c2">
            <router-link :to="{ name: 'Canny' }">
              <div :class="{ current: $route.name === 'Canny' }">
                <i class="fas fa-bullhorn" style="margin-right: 6px"></i>
                <span>Deixe a sua Sugestão</span>
              </div>
            </router-link>
          </div>
          <div class="account-name middle flex">
            <div class="name flex column">
              <small>Parceiro:</small>
              <small
                ><b>{{ account.name }}</b></small
              >
            </div>
            <router-link v-if="hasMultipleAccounts" :to="{ name: 'Account' }">
              <div class="button secondary">
                <i class="fas fa-exchange-alt"></i>
              </div>
            </router-link>
          </div>
          <a @click="logout()" class="button secondary"
            ><i class="fas fa-sign-out-alt"></i
          ></a>
        </div>
      </section>

      <section class="content-container flex w100 center">
        <div
          v-if="
            (!isAccountBlocked && !isAccountLimitExceeded) ||
              ((isAccountLimitExceeded || isAccountBlocked) &&
                subscriptionRoute)
          "
          class="max-1200 w100"
        >
          <slot></slot>
        </div>
        <div v-else-if="isAccountBlocked" class="max-1200 w100">
          <blocked></blocked>
        </div>
        <div v-else-if="isAccountLimitExceeded" class="max-1200 w100">
          <limit-exceeded></limit-exceeded>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
// import SubscriptionFlag from "@/components/subscriptionFlag/SubscriptionFlag";
import Blocked from "@/components/blocked/Blocked";
import LimitExceeded from "@/components/blocked/LimitExceeded";

import { mapState } from "vuex";

import { Account } from "@/services/account";
import { getUser, AccountsList } from "@/services/user";

export default {
  name: "Dashboard",
  components: {
    Breadcrumb,
    // SubscriptionFlag,
    Blocked,
    LimitExceeded,
    // ModalOnboarding,
  },
  data() {
    return {
      activeExpand: false,
      accounts: [],
    };
  },
  mounted() {
    if (!this.account.status) {
      this.getAccountInfo();
    }

    if (!this.user.id) {
      this.getUserInfo();
    }

    this.getAccountsList();
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    showOnboarding() {
      if (!this.user || (this.user && this.user.complet_onboarding === "")) {
        return false;
      }

      // return true

      return this.user && !this.user.complet_onboarding;
    },
    hasMultipleAccounts() {
      return this.accounts && this.accounts.length > 1;
    },
    isDemo() {
      let demoAccId =
        process && process.env && process.env.VUE_APP_DEMO_ACCOUNT;
      return demoAccId == this.account.id;
    },
    isAccountBlocked() {
      return this.account && this.account.status === "BLOCKED";
    },
    isAccountLimitExceeded() {
      return this.account && this.account.status === "LIMIT_EXCEEDED";
    },
    subscriptionRoute() {
      return this.$route.name == "ConfigAccount";
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
      });
    },
    getUserInfo() {
      getUser().then((result) => {
        this.$store.dispatch("auth", result);
      });
    },
    getAccountsList() {
      AccountsList().then((response) => {
        this.accounts = response;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-bar {
  .button.secondary {
    background: none;
    color: var(--primary);
    border: 0px;
    white-space: nowrap;
    padding: 12px 16px;
    font-size: 1.5rem;
    display: inline-block;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      background: var(--primary);
      color: #fff !important;
    }
  }
}

.menu {
  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top-color: currentcolor;
    border-top-style: none;
    border-top-width: 0px;
    border-top: 1px solid #c2c2c235;
    padding: 0;
    margin: 8px 0;
  }
}
.account-name {
  padding-right: 12px;
  border-right: 1px solid var(--border);
  .name {
    margin-right: 12px;
  }
}
.app-title {
  font-size: 11px;
}
</style>
